// ======================================================
// 🎥📂 DATOS PARA EL COMPONENTE CONTROL
// ======================================================

const cicontrolitems = {

  // =========================================
  // 🖼️ IMAGEN DE FONDO
  // =========================================
  background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/MSCI_001.png",


  // =========================================
  // 🔗 LINKS SUPERIORES
  // =========================================
  links: [
    { texto: "Inicio", url: "/Cinterno" },
    { texto: "Metodología", url: "/Cinterno/Metodologia" },
    { texto: "Componentes de Control", url: "/Cinterno/Control" },
    { texto: "Organigrama", url: "/Cinterno/Organigrama" },
    { texto: "Evidencias", url: "/Cinterno/Evidencias" }
  ],


  // =========================================
  // 🎥 SECCIÓN DE VIDEO (ANTES DEL ACORDEÓN)
  // =========================================
  videos: [
    {
      id: 1,
      titulo: "",
      url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/cinterno/Control_Interno.mp4"
    }
  ],


  // =========================================
  // 📂 ESTRUCTURA DEL ACORDEÓN (DEBAJO DEL VIDEO)
  // =========================================
  acordeon: [

    // 🔹 SECCIÓN 1
    {
      titulo: "Ambiente de Control",
      archivos: [
        {
          nombre: "Estrategia de difusión del Código de Ética y Código de Conducta",
          url: "/Documento/80"
        },
      ]
    },

    // 🔹 SECCIÓN 2
    {
      titulo: "Administración de Riesgos",
      archivos: [
       
      ]
    },

    // 🔹 SECCIÓN 3
    {
      titulo: "Actividades de Control",
      archivos: [
       
      ]
    },

    // 🔹 SECCIÓN 4
    {
      titulo: "Información y Comunicación",
      archivos: [
       
      ]
    },

    // 🔹 SECCIÓN 5
    {
      titulo: "Supervisión y Mejora Continua",
      archivos: [
       
      ]
    }

  ]

};

export default cicontrolitems;